module.exports = __webpack_public_path__ + "99ce864a24418d85bba0c7b34f509f02.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-12.svg
// module id = 560
// module chunks = 0